(() => {
    var processEpsilonData = function (a) {
        // --- Decode Response ---
        if (a === '') {
            // If the response is blank, stop processing
            return;
        }
        var jData = JSON.parse(a);
        // --- End Decode Response ---

        let userProperties = {}

        // --- Push Company Details to GTM ---
        const companyDetails = {
            'company_name': jData.company.name,
            'domain': jData.company.domain,
            'country': jData.company.country,
            'address': jData.company.address,
            'company_state': jData.company.state,
            'city': jData.company.city,
            'zip': jData.company.zip,
            'country_iso_code': jData.company.country_iso_code,
            'industry': jData.company.industry,
            'sic': jData.company.sic,
            'sic_description': jData.company.sic_description,
            'naics': jData.company.naics,
            'naics_description': jData.company.naics_description,
            'employee_range': jData.company.employee_range,
            'employee_count': jData.company.employee_count,
            'revenue_range': jData.company.revenue_range,
            'annual_revenue': jData.company.annual_revenue,
            'is_blacklisted': jData.company.is_blacklisted,
            'state_code': jData.company.state_code,
            'region': jData.company.region,
        }
        userProperties = {...userProperties, ...companyDetails}
        window.dataLayer.push(companyDetails);
        // --- End Company Details to GTM ---

        // --- Push Segments to GTM ---
        window.dataLayer.push({
            'segment_ids': jData.segments.ids,
            'segment_names': jData.segments.names,
            'segment_lists': jData.segments.lists,
        });
        if (jData.segments.names) {
            window.dataLayer.push({
                'segments': jData.segments.names.join(','),
            });
        }
        // --- End Push Segments to GTM ---

        // --- Push Product Scores to GTM ---
        if (jData.scores.length !== 0) {
            for (var i = 0; i < jData.scores.length; i++) {
                var product = jData.scores[i].product;
                var scoreObject = {};
                scoreObject[product] = jData.scores[i];
                window.dataLayer.push(scoreObject);
            }
        }
        // --- End Push Product Scores to GTM ---
        if (jData.scores.length != 0 && jData.scores[0]) {
            var score = jData.scores[0];
            const productScores = {
                'buying_stage': score.buying_stage,
                'profile_fit': score.profile_fit,
            }
            window.dataLayer.push(productScores)
            userProperties = {...userProperties, ...productScores}
        }
        // --- Send Confidence Score to GTM ---
        window.dataLayer.push({
            'confidence': jData.confidence,
        });
        // --- End Send Confidence Score to GTM ---

        // --- Trigger Company Details Loaded in GTM ---
        window.dataLayer.push({
            'event': '6si_company_details_loaded',
        });
        // --- End Trigger Company Details Loaded in GTM ---

        if (window.zaraz) {
            window.zaraz.set('6sense_buying_stage', userProperties.buying_stage)
            window.zaraz.set('6sense_profile_fit', userProperties.profile_fit)
            window.zaraz.set('6sense_industry', userProperties.industry)
            window.zaraz.set('6sense_company_name', userProperties.company_name)
            window.zaraz.set('6sense_region', userProperties.region)
        }
    };

    window._6si = window._6si || [];
    window.dataLayer = window.dataLayer || [];
    window._6si.push(['enableEventTracking', true]);
    window._6si.push(['setToken', '0f29703d4a5edd75b0ea9aac61862a51']); // REPLACE ME
    window._6si.push(['setEpsilonKey', '1bdf5ded4ea2a87b70edd37ee03aca4f25fca385']); // REPLACE ME
    window._6si.push(["setEndpoint", "b.6sc.co"]);
    var epsilonName = 'enableCompanyDetails';
    var enabled = true; // set to true to enable API
    var callback = processEpsilonData; // optional callback
    var version = 3; // 3 for v3
    window._6si.push([epsilonName, enabled, callback, version]);
    (function () {
        var gd = document.createElement('script');
        gd.type = 'text/javascript';
        gd.async = true;
        gd.src = 'https://j.6sc.co/6si.min.js';
        var s = document.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(gd, s);
    })();
})();
